import React, {  } from 'react';
import {  } from 'antd';
import { PlusIcon } from '../../../component/icon/Icon';


interface HangPlusIconProps extends React.ComponentProps<any> {
    position: {
        left?: number;
        right?: number;
        top?: number;
        bottom?: number;
    }
}

/**
 * 一个接收定位数据的icon
 */
const HangPlusIcon = (props: HangPlusIconProps) => {
    const {
        position = {
            left: 'auto', 
            right: 'auto', 
            top: 'auto', 
            bottom: 'auto', 
        },
        ...restProps
    } = props;


    return (
        <PlusIcon className="pa f33" style={{...position}} {...restProps} />
    );
};

export { HangPlusIcon };